<template>
    <div>
        <div class="d-flex justify-content-center">
            <b-overlay :show="busySaving">
                <div class="d-flex flex-column align-items-center">
                    <div class="align-items-center">
                        <img src="@/assets/images/tfp_condensed_logo.png" alt height="200" />
                    </div>
                    <h4 class="mt-4 mb-4">Sales Lead</h4>
                </div>
                <hr />
                <div>
                    <b-form class="mw-500 mb-4">
                        <!-- Your form groups and inputs here -->
                        <b-form-group id="example-input-group-1" label="First Name:" label-for="example-input-1">
                            <b-form-input
                                id="example-input-1"
                                name="example-input-1"
                                aria-describedby="input-1-live-feedback"
                                class="input-500"
                                v-model="$v.form.first_name.$model"
                                :state="validateState('first_name')"
                            ></b-form-input>

                            <b-form-invalid-feedback id="input-1-live-feedback"
                                >This is a required field and must be at least 2 characters.</b-form-invalid-feedback
                            >
                        </b-form-group>
                        <b-form-group id="example-input-group-1" label="Last Name:" label-for="example-input-1">
                            <b-form-input
                                v-model="$v.form.last_name.$model"
                                :state="validateState('last_name')"
                                id="example-input-1"
                                name="example-input-1"
                                aria-describedby="input-1-live-feedback"
                            ></b-form-input>

                            <b-form-invalid-feedback id="input-1-live-feedback"
                                >This is a required field and must be at least 2 characters.</b-form-invalid-feedback
                            >
                        </b-form-group>

                        <b-form-group id="example-input-group-1" label="Contact No: (must start with 0)" label-for="example-input-1">
                            <b-form-input
                                id="example-input-1"
                                name="example-input-1"
                                aria-describedby="input-1-live-feedback"
                                v-model="$v.form.contact_no.$model"
                                :state="validateState('contact_no')"
                            ></b-form-input>

                            <b-form-invalid-feedback id="input-1-live-feedback">Contact Numbers are 10 digits</b-form-invalid-feedback>
                        </b-form-group>

                        <b-form-group id="example-input-group-1" label="Email:" label-for="example-input-1">
                            <b-form-input
                                v-model="$v.form.email.$model"
                                :state="validateState('email')"
                                type="email"
                                id="example-input-1"
                                name="example-input-1"
                                aria-describedby="input-1-live-feedback"
                            ></b-form-input>

                            <b-form-invalid-feedback id="input-1-live-feedback">Needs to be a valid email format</b-form-invalid-feedback>
                        </b-form-group>
                        <b-form-group label="Province:">
                            <b-form-select
                                v-model="$v.form.province.$model"
                                :state="validateState('province')"
                                :options="province_options"
                                id="client-type"
                                name="client-type"
                                aria-describedby="client-type-live-feedback"
                            ></b-form-select>
                            <b-form-invalid-feedback id="client-type-live-feedback">This is a required field.</b-form-invalid-feedback>
                        </b-form-group>
                        <b-form-group label="Type:">
                            <b-form-select
                                v-model="$v.form.type.$model"
                                :state="validateState('type')"
                                :options="type_options"
                                id="client-type"
                                name="client-type"
                                aria-describedby="client-type-live-feedback"
                            ></b-form-select>
                            <b-form-invalid-feedback id="client-type-live-feedback">This is a required field.</b-form-invalid-feedback>
                        </b-form-group>

                        <b-form-checkbox
                            id="checkbox-1"
                            v-model="form.newsletter"
                            name="checkbox-1"
                            value="true"
                            unchecked-value="false"
                            size="lg"
                            class="float-left"
                        >
                            Newsletter
                        </b-form-checkbox>
                    </b-form>
                    <div class="modal-footer mt-4">
                        <b-button @click="saveLead" variant="primary">Save Lead</b-button>
                        <b-button @click="clear" variant="warning">Clear / Cancel</b-button>
                    </div>
                </div>
            </b-overlay>
        </div>
    </div>
</template>

<script>
import { crmMethods, crmComputed } from "@/state/helpers";
//eslint-disable-next-line
import { required, minLength, maxLength, email } from "vuelidate/lib/validators";
//eslint-disable-next-line
import Swal from "sweetalert2";

export default {
    data: () => ({
        busySaving: false,
        formSubmit: false,
        form: {
            first_name: "",
            last_name: "",
            contact_no: "",
            email: "",
            province: null,
            type: null,
            newsletter: "false",
        },
        province_options: [
            { value: null, text: "Please select an option" },
            { value: "Western Cape", text: "Western Cape" },
            { value: "Eastern Cape", text: "Eastern Cape" },
            { value: "Free State", text: "Free State" },
            { value: "Gauteng", text: "Gauteng" },
            { value: "KwaZulu-Natal", text: "KwaZulu-Natal" },
            { value: "Limpopo", text: "Limpopo" },
            { value: "Mpumalanga", text: "Mpumalanga" },
            { value: "North-West", text: "North-West" },
            { value: "Northern-Cape", text: "Northern-Cape" },
        ],
        type_options: [
            { value: null, text: "Please select an option" },
            { value: "stockist", text: "Stockist" },
            { value: "reseller", text: "Representative / Reseller" },
            { value: "individual", text: "Individual" },
        ],
    }),
    validations: {
        form: {
            first_name: {
                required,
                minLength: minLength(2),
            },
            last_name: {
                required,
                minLength: minLength(2),
            },
            contact_no: {
                required,
                minLength: minLength(10),
                maxLength: maxLength(10),
            },
            email: {
                required,
                email,
            },
            province: {
                required,
            },
            type: {
                required,
            },
        },
    },
    computed: {
        ...crmComputed,
    },
    methods: {
        ...crmMethods,
        refreshPage() {
            window.location.reload();
        },
        clear() {
            Swal.fire({
                title: `Clear the form?`,
                text: `Are you sure?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Confirm",
            }).then((result) => {
                if (result.value) {
                    //
                    this.reset();
                }
            });
        },
        reset() {
            this.form = {
                first_name: "",
                last_name: "",
                contact_no: "",
                email: "",
                province: null,
                type: null,
                newsletter: "false",
            };
            this.formSubmit = false;
            this.busySaving = false;
        },
        validateState(name) {
            if (this.formSubmit) {
                const { $dirty, $error } = this.$v.form[name];
                return $dirty ? !$error : null;
            }
        },
        saveLead() {
            this.formSubmit = true;

            this.$v.form.$touch();
            if (this.$v.form.$anyError) {
                return;
            }
            this.busySaving = true;
            Swal.fire({
                title: `Save Lead?`,
                // text: `${item.name}`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Confirm",
            }).then((result) => {
                if (result.value) {
                    this.form.newsletter == "false" ? (this.form.newsletter = false) : (this.form.newsletter = true);

                    this.saveIncomingSalesLead(this.form).then(() => {
                        Swal.fire(`Lead Saved`, "", "success");
                        this.busySaving = false;
                        this.reset();
                    });
                }
            });
        },
    },
    mounted() {},
};
</script>

<style lang="scss" scoped>
.mw-500 {
    max-width: 500px !important;
}
.input-500 {
    width: 500px;
}

@media only screen and (max-width: 510px) {
    .input-500 {
        width: 300px;
    }
}
@media only screen and (max-width: 310px) {
    .input-500 {
        width: 200px;
    }
}
</style>
